<template>
  <div class="repost-page">
    <div class="search-container" id="search">
      <div class="back-icon" v-show="!explore" @click="backClick"></div>
      <div class="search-input">
        <div class="search-icon"></div>
        <input
          @click="showSearchResult = true"
          autocomplete="off"
          v-model="inputVal"
          @input="search"
          placeholder="Search & Repost"
        />
        <div
          ref="search"
          v-show="showSearchResult"
          class="search-result-container"
        >
          <div class="tab-list-container">
            <div
              @click="switchTab(type)"
              v-for="type in searchTypeList"
              :key="type.id"
              class="tab-item"
              :class="{ select: type.select }"
            >
              {{ type.text }}
            </div>
          </div>
          <div
            class="result-container"
            v-for="type in searchTypes"
            v-show="searchTypeId === type.id"
          >
            <search-list
              ref="searchList"
              @itemClick="itemClick"
              :type="type.id"
            ></search-list>
          </div>
        </div>
      </div>
      <div class="refresh-icon" @click="refreshClick"></div>
    </div>
    <div class="main-container">
      <search-result-list
        v-show="!explore"
        ref="searchResult"
      ></search-result-list>
      <search-result-list
        v-show="explore"
        type="explore"
        ref="searchExplore"
      ></search-result-list>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import SearchList from "../../components/repost/SearchList";
import SearchResultList from "../../components/repost/PostSearchResult";
import { showErrorMsg } from "../../utils/errors";
import {
  CURRENT_PUBLISHER_ID,
  REPOST_HISTORY,
} from "../../store/mutation-types";
import { mapGetters } from "vuex";

export default {
  name: "SearchRepostPage",
  components: { SearchResultList, SearchList },
  data() {
    return {
      searchTypeId: 0,
      showSearchResult: false,
      inputVal: "",
      showDetail: false,
      explore: true,
      explorePublisherId: "", // 当前explore的publisher
      searchTypes: [
        {
          id: 0,
          text: "Top",
        },
        {
          id: 1,
          text: "People",
        },
        {
          id: 2,
          text: "Tags",
        },
        {
          id: 3,
          text: "Places",
        },
      ],
    };
  },
  watch: {
    $route: {
      async handler(val) {
        if (val.query.type === "repost" && val.query.searchType) {
          const item = { ...val.query };
          item.type = item.searchType;
          this.explore = false;
          this.$nextTick(async () => {
            this.inputVal = item.searchText;
            await this.$refs.searchResult.reload({ item });
          });
        }
      },
      immediate: true,
      deep: true,
    },
    async inputVal(val) {
      if (!val) {
        this.$refs.searchList[this.searchTypeId].clear();
      }
    },
    currentPublisherId() {
      this.$router.replace({
        name: "SchedulePage",
        query: { type: "repost" },
      });
      if (this.explore) {
        this.refreshPage();
      }
      this.explore = true;
    },
    explore() {
      this.refreshPage();
    },
  },
  methods: {
    // 跳转到对应ins详情页
    async toInsProfile(model) {
      this.explore = false;
      const item = {
        type: "InstagramUser",
        id: `${model.user.social_uid}`,
      };
      this.$router.replace({
        name: "SchedulePage",
        query: {
          ...this.$route.query,
          searchText: this.inputVal,
          searchType: item.type,
          id: item.id,
        },
      });
    },
    switchTab(type) {
      this.searchTypeId = type.id;
      if (this.inputVal) {
        this.$refs.searchList[this.searchTypeId].change(this.inputVal);
      } else {
        this.$refs.searchList[this.searchTypeId].clear();
      }
    },
    search: _.debounce(async function (e) {
      const val = e.target.value;
      if (val) {
        this.$refs.searchList[this.searchTypeId].change(this.inputVal);
      } else {
        this.$refs.searchList[this.searchTypeId].clear();
      }
    }, 500),
    /**
     * 选中某条点击事件，获取对应条目信息
     */
    async itemClick(item) {
      this.explore = false;
      try {
        item.searchTypeId = this.searchTypeId;
        this.showSearchResult = false;
        this.$router.replace({
          name: "SchedulePage",
          query: {
            ...this.$route.query,
            searchType: item.type,
            id: item.id,
            searchText: this.inputVal,
          },
        });
        // 保存选中项
        let history = this.$store.getters[REPOST_HISTORY];
        // 添加时判断是否存在同类型的相同Id
        const filter = history.filter(
          (h) => !(h.id === item.id && h.searchTypeId === this.searchTypeId)
        );
        history = [item, ...filter];
        if (history.length > 20) {
          history.splice(history.length - 1, 1);
        }
        this.$store.commit(REPOST_HISTORY, history);
      } catch (e) {
        showErrorMsg(e);
      }
    },
    backClick() {
      this.explore = true;
      this.$router.replace({
        name: "SchedulePage",
        query: { type: "repost" },
      });
    },
    refreshClick() {
      if (this.explore) {
        this.$refs.searchExplore.reload({});
      } else {
        this.$refs.searchResult.reload({});
      }
    },
    refreshPage() {
      // 判断当前是否为expolre页面，如果是则刷新页面
      if (this.explore && this.explorePublisherId !== this.currentPublisherId) {
        this.$refs.searchExplore.reload({});
      }
    },
  },
  computed: {
    ...mapGetters({
      currentPublisherId: CURRENT_PUBLISHER_ID,
    }),
    /**
     * 查询的类型
     */
    searchTypeList() {
      return this.searchTypes.map((type) => {
        return {
          id: type.id,
          text: type.text,
          select: type.id === this.searchTypeId,
        };
      });
    },
  },
  mounted() {
    function container(e) {
      let $el = e.target;
      while (true) {
        if ($el.id === "search") {
          return true;
        } else {
          $el = $el.parentNode;
          if ($el === document.body) {
            return false;
          }
        }
      }
    }

    // 点击其他区域消失
    window.document.addEventListener("click", (e) => {
      if (!container(e)) {
        this.showSearchResult = false;
      }
    });
  },
  created() {
    this.$bus.$on("getSavedInfo", async ({ mediaId, type, callback }) => {
      if (this.explore) {
        const switchInfo = await this.$refs.searchExplore.getCurrentInfo({
          mediaId,
          type,
        });
        /* eslint-disable */
        callback({ switchInfo });
      } else {
        const switchInfo = await this.$refs.searchResult.getCurrentInfo({
          mediaId,
          type,
        });
        callback({ switchInfo });
      }
    });
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/style/theme.less";

.repost-page {
  flex: 1;
  display: flex;
  flex-direction: column;

  .search-container {
    height: 50px;
    padding: 0 29px;
    position: relative;
    display: flex;
    align-items: center;
    border-bottom: 1px solid @border-color;

    .back-icon {
      height: 25px;
      width: 25px;
      background: url("../../../public/images/common/Back@3x.png");
      background-size: contain;
      margin-right: 10px;
      cursor: pointer;

      &:hover,
      &:active {
        opacity: 0.7;
      }
    }

    .refresh-icon {
      height: 25px;
      width: 25px;
      background-size: contain;
      background-image: url("../../../public/images/d&d/refresh.png");
      cursor: pointer;
      margin-left: 10px;

      &:hover,
      &:active {
        opacity: 0.7;
      }
    }

    .search-input {
      height: 34px;
      background-color: #f0f0f0;
      border-radius: 4px;
      border: solid 1px #dcdfe6;
      position: relative;
      padding: 0 15px;
      display: flex;
      align-items: center;
      flex: 1;

      .search-result-container {
        position: absolute;
        left: -1px;
        right: -1px;
        height: 375px;
        border: solid 1px #dcdfe6;
        top: 41px;
        background: white;
        display: flex;
        flex-direction: column;
        z-index: 500;

        .tab-list-container {
          height: 40px;
          margin: 0 20px;
          border-bottom: 1px solid #e6e6e6;
          display: flex;
          justify-content: space-around;
          padding: 0 20px;

          .tab-item {
            flex: 1;
            font-size: 14px;
            color: @font-color-gray;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 20px;
            cursor: pointer;
            border-bottom: 2px solid transparent;

            &.select {
              color: black;
              border-bottom-color: black;
            }
          }
        }

        .result-container {
          flex: 1;
          overflow: auto;
          padding: 10px 0;
        }
      }

      .search-icon {
        background-image: url("../../../public/images/repost/search.png");
        width: 18px;
        height: 18px;
        background-size: cover;
        margin-right: 14px;
      }

      input {
        font-size: 14px;
        line-height: 44px;
        height: 44px;
        background: transparent;
        border: 0;
        flex: 1;
        padding: 0;
      }
    }
  }

  .main-container {
    flex: 1;
    display: flex;
    justify-content: center;
    overflow: auto;
  }
}
</style>
